/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgBackParent = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path
      d="M22 19H10V5.4l-5.3 5.3-1.4-1.4L11 1.6l7.7 7.7-1.4 1.4L12 5.4V17h10z"
      fill="currentcolor"
    />
  </Icon>
);
export { SvgBackParent as BackParent };
